import { extractErrorMessage } from '@/utils/extractErrorMessage'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { changePassword, getBrand, updateBrand } from './service'
import type { ApiErrorResponse } from './types'

export const useBrandQuery = () => {
  return useQuery({
    queryKey: ['brand'],
    queryFn: getBrand,
  })
}

export const useChangePasswordMutation = () => {
  return useMutation({
    mutationFn: changePassword,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      let errorMessage = 'Something went wrong'
      const errorStatus = error?.response?.status
      if (errorStatus === 422) errorMessage = 'Wrong Current Password'
      toast.error(errorMessage)
    },
  })
}

export const useUpdateBrandMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateBrand,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['brand'] })
    },
    onError: (error: AxiosError<ApiErrorResponse>) => {
      toast.error(extractErrorMessage(error))
    },
  })
}
